import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-work-item-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWorkItemIconProps extends SvgIconProps {}

/**
 * Component used to return wotkitem icon
 * @param props -
 * @example
 * @returns
 */
export function CcfWorkItemIcon(props: CcfWorkItemIconProps) {
  return (
    <SvgIcon {...props} width="16" height="20" viewBox="0 0 16 20" fill="rgb(0, 124, 190)">
      <path d="M4.8 2.3998H15.2C15.68 2.3998 16 2.0798 16 1.5998C16 1.1198 15.68 0.799805 15.2 0.799805H4.8C4.32 0.799805 4 1.1198 4 1.5998C4 2.0798 4.32 2.3998 4.8 2.3998ZM15.2 4.7998H4.8C4.32 4.7998 4 5.1198 4 5.5998C4 6.0798 4.32 6.3998 4.8 6.3998H15.2C15.68 6.3998 16 6.0798 16 5.5998C16 5.1198 15.68 4.7998 15.2 4.7998ZM15.2 8.7998H4.8C4.32 8.7998 4 9.11981 4 9.5998C4 10.0798 4.32 10.3998 4.8 10.3998H15.2C15.68 10.3998 16 10.0798 16 9.5998C16 9.11981 15.68 8.7998 15.2 8.7998ZM15.2 12.7998H4.8C4.32 12.7998 4 13.1198 4 13.5998C4 14.0798 4.32 14.3998 4.8 14.3998H15.2C15.68 14.3998 16 14.0798 16 13.5998C16 13.1198 15.68 12.7998 15.2 12.7998ZM1.6 0.799805H0.8C0.32 0.799805 0 1.1198 0 1.5998C0 2.0798 0.32 2.3998 0.8 2.3998H1.6C2.08 2.3998 2.4 2.0798 2.4 1.5998C2.4 1.1198 2.08 0.799805 1.6 0.799805ZM1.6 4.7998H0.8C0.32 4.7998 0 5.1198 0 5.5998C0 6.0798 0.32 6.3998 0.8 6.3998H1.6C2.08 6.3998 2.4 6.0798 2.4 5.5998C2.4 5.1198 2.08 4.7998 1.6 4.7998ZM1.6 8.7998H0.8C0.32 8.7998 0 9.11981 0 9.5998C0 10.0798 0.32 10.3998 0.8 10.3998H1.6C2.08 10.3998 2.4 10.0798 2.4 9.5998C2.4 9.11981 2.08 8.7998 1.6 8.7998ZM1.6 12.7998H0.8C0.32 12.7998 0 13.1198 0 13.5998C0 14.0798 0.32 14.3998 0.8 14.3998H1.6C2.08 14.3998 2.4 14.0798 2.4 13.5998C2.4 13.1198 2.08 12.7998 1.6 12.7998Z"/>
    </SvgIcon>
  );
}

export default CcfWorkItemIcon;
